import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CapTaskResourceGet, CapTaskService, GetCapTaskResourceParams } from '@app/services/cap-task.service';

@Component({
    selector: 'tt-cap-task-resource',
    templateUrl: './cap-task-resource.component.html',
    styleUrls: ['./cap-task-resource.component.css'],
})
export class CapTaskResourceComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetCapTaskResourceParams;

    public page?: CapTaskResourceGet;

    public settingStatus?: '100' | '200' | '300';

    public get canStartWorking(): boolean {
        const status = this.page?.postatus_no;
        return status !== undefined && (Number(status) <= 100 || status === '300');
    }

    public isPositiveNumber(value: string): boolean {
        return Number(value) > 0;
    }

    constructor(
        private capTask: CapTaskService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async setStatus(status: '100' | '200' | '300') {
        if (!this.page) return;

        try {
            this.settingStatus = status;

            const { errorcode, errormessage } = await this.capTask.setStatus({ captaskresource_keyno: this.page.captaskresource_keyno, new_postatus_no: status });

            if ('' + errorcode !== '0') {
                await this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                await this.loadPage();
            }
        } catch (error) {
            console.error(error);
        } finally {
            delete this.settingStatus;
        }
    }

    private async loadPage() {
        if (!!this.params) {
            this.page = await this.capTask.getCapTaskResource(this.params);
        }
    }

    private async init() {
        await this.loadPage();
        this.navigator?.setHeading?.(this.page?.page_heading ?? '');
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: 'min(160rem, 98vw)', height: 'min(90rem, 98vh)' });
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }
}
